import React,{useState,useEffect} from "react";
import ApptHeader from "./ApptHeader";
import MiniCalendar from "./MiniCalendar";
import NoAppointment from "./NoAppointment";
import appointmentService from "../../../services/appointment.service";
import clinicService from "../../../services/clinic.service";
import Loading from "../../common/Loading"
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useEyeconxStore } from "../../../store/eyeconxStore";
import AppointmentList from "./AppointmentList";
function Appointments() {
  const navigate = useNavigate()
  const [loading,setLoading] = useState(false)
  const user = useEyeconxStore(state => state.user)
  const [appointmentDate,setAppointmentDate] = useState(new Date())
  const [totalAppointment,setTotalAppointment] = useState(0)
  const [confirmedAppointment,setConfirmedAppointment] = useState(0)
  const [apptTitle,setApptTitle] = useState("")
  const [docId,setDocId] = useState(0)
  const [doctorList,setDoctorList] = useState([])
 const [appointmentList,setAppointmentList] = useState([])
  const [checkedItems,setCheckedItems] = useState([])
  const [isAllSelected,setIsAllSelected] = useState(false)
  const changeDate = (date) => {
    setAppointmentDate(date)
  }

  useEffect(()=>{
    if(user.role === "ROLE_MANAGER"){
      getDoctorList()
    }
    
  },[])
  //check if it is today's date 
  useEffect(()=>{
    const today = new Date();
    const date = new Date(appointmentDate);
    if(date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()){
      setApptTitle("Today's Appointment")
    }else{ setApptTitle("Appointments on "+date.toDateString())
    } 
    getAppointment()  
  },[appointmentDate,docId])

  const getAppointment = ()=>{
    setLoading(true)
     console.log("appointmentDate",appointmentDate)
     
const year = appointmentDate.getFullYear();
const month = String(appointmentDate.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed
const day = String(appointmentDate.getDate()).padStart(2, '0');

// Form the desired date string in "YYYY-MM-DD" format
const apptdate = `${year}-${month}-${day}`;
      appointmentService.getAppointment(user.clinicId,apptdate,docId)
      .then(res=>{
        setLoading(false)
        setAppointmentList(res.data.appointmentsList)
        setTotalAppointment(res.data.totalAppointments)
        setConfirmedAppointment(res.data.confirmedAppointments)
      })
      .catch(err=>{
        setLoading(false)
       // toast.error("Error while getting appointment")
      })
  }

  const getDoctorList = ()=>{
    clinicService.getUserByRole(user.clinicId,"ecp")
    .then(res=>{
      setDoctorList(res.data)
    })
    .catch(err=>{
      toast.error("Error While getting Doctor List")
    })
    
  }

  const handleDocChange = (e)=>{
    setDocId(e.target.value)
  }

  const handleCheckboxChange = (e) =>{
    const { checked, value } = e.target;
    if (checked) {
      setCheckedItems([...checkedItems, value]);
    } else {
      setCheckedItems(checkedItems.filter(item => item !== value));
    }
  }
  const handleAllSelect = (e)=>{
    const {checked, value} = e.target
    if(checked){
      setIsAllSelected(true)
      setCheckedItems(appointmentList.map(appt=>{
        return appt.appointmentId+" "+appt.firstName+" "+appt.lastName
      }))
    }else{
      setIsAllSelected(false)
      setCheckedItems([])
    }
  }
  return (
    <>
      <ApptHeader totalAppointment={totalAppointment} confirmedAppointment={confirmedAppointment} />
      <div className="app-container container-xxl">
        <div className="row">
          <div className="col-md-3">
            <MiniCalendar currentDate = {appointmentDate} changeDate={changeDate} />

            {checkedItems.length>0?<>
              
              <div className="mt-5 p-5 bg-light border rounded">
                <span className="text-muted fw-bold">
                  Selected Patients
                </span>
                {checkedItems.map((item, index) => (
                  <div key={index} >
                    <span className="text-muted">{item}</span>
                  </div>
                ))}
              </div>
              
            </>:""}
          </div>

          <div className="col-md-9">
                <div className="card">
                  <div className="card-header border-0 pt-5"> 
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold fs-3 mb-1">{apptTitle}</span>
                      <span className="text-muted mt-1 fw-semibold fs-7">Total: 0 Confirmed: 0</span>
                    </h3>
                    <div className="card-toolbar">
                      <div className="d-flex flex-row justify-content-end">

                     
                    
                      {user && user.role === "ROLE_MANAGER"?
                      <select className="form-select form-select-sm form-select-solid" onChange={handleDocChange}>
                        <option value="0">All Doctors</option>
                        {doctorList.map(doc=>{
                          return <option value={doc.id}>{doc.firstName} {doc.lastName}</option>
                        })}
                      </select>
                      :""}
                       </div>
                      
                    </div>
                    {checkedItems.length>0?<>
                    <div className="d-flex flex-row justify-content-between align-items-center w-100">
                        <span className="text-muted me-2">{checkedItems.length} selected</span>
                        <div>
                       
                        <button className="btn btn-sm btn-light-primary me-2"> <i className="bi bi-phone"></i>  Sms</button>
                        <button className="btn btn-sm btn-light-info me-2"> <i className="bi bi-envelope-fill"></i>  Email</button>
                        <button className="btn btn-sm btn-light-success me-2 mb-2"> <i className="bi bi-clipboard-check"></i> Survey</button>
                        <button className="btn btn-sm btn-light-primary me-2 mb-2"><i className="bi bi-card-text"></i> Articles </button>
                           <button className="btn btn-sm btn-light-info me-2 mb-2"> <i className="bi bi-eyeglasses"></i> Glass Pickup </button>
                           <button className="btn btn-sm btn-light-success me-2 mb-2"> <i className="bi bi-dash-circle"></i> Contact Lens Pickup </button>
                        </div>
                        
                    </div>
                    </>:""}
                  </div>
                  <div className="card-body">
                  
                    {loading?<Loading/>:<>
                        {appointmentList.length>0?<AppointmentList 
                                appointmentList={appointmentList} 
                                checkedItems={checkedItems} 
                                handleCheckboxChange={handleCheckboxChange} 
                                isAllSelected={isAllSelected}
                                handleAllSelect={handleAllSelect}/>:
                          <NoAppointment/>

                                }
                    </>}
                     
                  </div>
                </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Appointments;
